/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

export const FlexRow = ({style, direction, wrap, children, className, margin, onClick}) => (
    <div onClick={onClick} className={"p-flex"
        + (wrap ? " p-flex-wrap" : "")
        + (style ? " " + style : "")
        + (direction ? " p-flex-" + direction : "")
        + (margin ? " p-margin-" + margin : "")
        + (className ? " " + className : "")}>
        {children}
    </div>);

FlexRow.styles = {
    spaceBetween: "p-justify-space-between",
    center: "p-flex-justify-content-center"
};

FlexRow.directions = {
    column: 'column',
    row: 'row'
};

FlexRow.margin = {
    sm: "sm"
};

FlexRow.propTypes = {
    style: PropTypes.oneOf(Object.values(FlexRow.styles)),
    direction: PropTypes.oneOf(Object.values(FlexRow.directions)),
    wrap: PropTypes.bool,
    children: PropTypes.any.isRequired
};
